/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Dialog, Typography2 } from '@coursera/cds-core';

import type { Props as ModalButtonFooterProps } from 'bundles/authoring/common/modals/cds/ModalButtonFooter';
import ModalButtonFooter from 'bundles/authoring/common/modals/cds/ModalButtonFooter';

type Props = {
  title: React.ReactNode;
  content: React.ReactNode;
  primaryButtonContents: string;
  cancelButtonContents?: string;
  hideCancelButton?: boolean;
  onCancelButtonClick: () => void;
  onPrimaryButtonClick: () => void;
  modalButtonFooterProps?: ModalButtonFooterProps;
};

const styles = {
  title: css`
    margin: var(--cds-spacing-150) 0 var(--cds-spacing-400);
  `,
  content: css`
    p {
      margin-bottom: var(--cds-spacing-150);
    }
  `,
  actions: css`
    .slide-out-modal-button-footer {
      margin-top: 0;
    }
  `,
};

const AssessmentModalLayout = ({
  title,
  content,
  onCancelButtonClick,
  onPrimaryButtonClick,
  primaryButtonContents,
  cancelButtonContents,
  hideCancelButton,
  modalButtonFooterProps,
}: Props) => {
  return (
    <Dialog
      open={true}
      onClose={onCancelButtonClick}
      aria-describedby="dialog-content"
      aria-labelledby="dialog-heading"
      data-testid="AssessmentModalLayout"
    >
      {title && <Dialog.HeadingGroup id="dialog-heading">{title as React.ReactText}</Dialog.HeadingGroup>}
      {content && (
        <Dialog.Content id="dialog-content">
          <Typography2 component="div" variant="bodyPrimary" css={styles.content} id="dialog-heading">
            {content}
          </Typography2>
        </Dialog.Content>
      )}
      <Dialog.Actions css={styles.actions}>
        <ModalButtonFooter
          onPrimaryButtonClick={onPrimaryButtonClick}
          onCancelButtonClick={hideCancelButton ? undefined : onCancelButtonClick}
          primaryButtonContents={primaryButtonContents}
          cancelButtonContents={cancelButtonContents}
          {...modalButtonFooterProps}
        />
      </Dialog.Actions>
    </Dialog>
  );
};

export default AssessmentModalLayout;
